import React, { useState, useEffect } from 'react'
import { Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap'
import { navigate } from '@reach/router'

const CreatePeriodButton = () => {

  const [isLoading, setIsLoading] = useState(false)

  const onClickHandler = () => {
    setIsLoading(true)
  }

  useEffect(() => {
    isLoading && (
      navigate('/admin/periodos/nuevo')
      .then(() => setIsLoading(false))
    )      
  }, [isLoading])

  return (
    <OverlayTrigger
      overlay={
        <Tooltip>
         <strong>Registrar nuevo periodo</strong>
        </Tooltip>
      }
      placement="bottom"
    >
      <Button className="mr-1" variant="success" onClick={onClickHandler} >
        { isLoading 
          ? <Spinner size="sm" animation="border" variant="light" /> 
          : (
            <span className="fa-stack" style={{height: 'auto', verticalAlign: 'top', lineHeight: 1.5 }}>
              <i className="fa fa-stack-1x fa-calendar" style={{ fontSize: '1.1em' }} />
              <i className="fa fa-stack-1x fa-plus" style={{ fontSize: '1em', marginTop: '0.6em', marginLeft: '0.65em' }} />
            </span>
          )
        }
      </Button>
    </OverlayTrigger>
  )
}

export default CreatePeriodButton